module.exports = __webpack_public_path__ + "static/media/pragmatic7000m.d4a8e885.webp";